import { Component, OnInit } from '@angular/core';
import { NgSelectModule, NgSelectConfig } from '@ng-select/ng-select';
import { Router } from '@angular/router';
import { CurrencyConversionService } from '../Services/currency-conversion.service';
import { CurrencyInfo, CurrencyConversionProperties } from '../Models/CurrencyConversionProperties';

@Component({
  selector: 'app-currency-conversion',
  templateUrl: './currency-conversion.component.html',
  styleUrls: ['./currency-conversion.component.css']
})
export class CurrencyConversionComponent implements OnInit {
  currencyArray: CurrencyInfo[] = [];
  inputCurrencyInfo = new CurrencyConversionProperties();
  constructor(private authService: CurrencyConversionService,private routerr: Router) { }

  ngOnInit(): void {

    this.authService.getCurrencyInformation().subscribe(data => {
      console.log(data)
      this.currencyArray = data;
    })

    this.authService.getAgencyCurrencyInformation("AG01").subscribe(data => {

      console.log(data);
      for (let a = 0; a < this.currencyArray.length; a++) {
        if (data.currencyInformProp == this.currencyArray[a].currencyInformProp.split("-")[0]) {
          this.inputCurrencyInfo.currencyTo = this.currencyArray[a].currencyInformProp;
        }
      }
    })

  }
  changeCurrency(currency) {

    for (let a = 0; a < this.currencyArray.length; a++) {
      if (currency.currencyInformProp == this.currencyArray[a].currencyInformProp) {
        this.inputCurrencyInfo.currencyValue = this.currencyArray[a].currencyvalue;
      }
    }

  }

  currencyApply() {
    //console.log(this.inputCurrencyInfo.currencyFrom);
    //console.log(this.inputCurrencyInfo.currencyTo);
    //console.log(this.inputCurrencyInfo.priceConversion);
    this.inputCurrencyInfo.currencyToCode = this.inputCurrencyInfo.currencyFrom.split("-")[0];
    this.inputCurrencyInfo.currencyToCountry = this.inputCurrencyInfo.currencyFrom.split("-")[2];
     
    console.log(this.inputCurrencyInfo);
    this.authService.updateCurrencyInformation(this.inputCurrencyInfo).subscribe(data => {
      if (data == true) {
        //localStorage.setItem("codeTo", this.inputCurrencyInfo.currencyTo.split("-")[0]);
        /*this.router.navigateByUrl("/");*/
        var response = document.querySelector(".save-message") as HTMLDivElement;
        response.style.color = 'green';
        response.innerHTML = "Currency Saved Successfully";
        this.routerr.navigateByUrl('/flightSearch');
        //setTimeout(function () {
        //  response.innerHTML = "";
          
        //}, 3000)
        
      } else {
        var response = document.querySelector(".save-message") as HTMLDivElement;
        response.style.color = 'red';
        response.innerHTML = "Something Went Wrong";
        setTimeout(function () {
          response.innerHTML = "";
        }, 3000)
      }


    })





  }




}
